<template>
<!-- 省市区 -->
    <div class="modal" :class="modalClass" v-show="showMask">
        <div class="modal-bg" @click="closeMask" v-if="iscloseMask"></div>
        <div class="modal-bg" v-else></div>
        <div class="modal-content" ref="monthPie" :style="widthStyle">
            <!-- <div class="modal-header" style="" v-if="title!=''">
                <span class="">{{title}}</span>
                <a class="close fr" heaf="javascript:void(0);" @click="closeMask">&times;</a>
            </div> -->
            <div class="modal-content2">
              <div class="modal-warp ac">
                  <slot name="mdBox"></slot>
              </div>
              <div class="modal-footer ac" v-if="modalFoot">
                  <div class="sig" v-if="type == 'alert'">
                      <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                  </div>
                  <div v-if="type != 'alert'">
                      <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                      <button class="btn btn-none" id="closeModal" @click="closeMask">{{cancelText}}</button>
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Dialog",
    props:{
        iscloseMask:{
          type:Boolean,
          default: false,
        },
        modalClass:{
            type:String,
            default:function(){
                return 'defModal';
            },
        },
        title:{
            type:String,
            default:function(){
                return '';
            },
        },
        width:{
            type:String,
            default:function(){
                return '90';
            },
        },
        type:{
            type:String,
            default:function(){
                return 'normal';
            },
        },
        modalFoot:{
            type:Boolean,
            default: true,
        },
        btnText:{
            type:String,
            default:function(){
                return 'YES';
            },
        },
        cancelText:{
            type:String,
            default:function(){
                return 'sure';
            },
        },
        callback:{
            type:Function
        }
    },
    data() {
        return {
            showMask: false,
            timer:'',
            loadText:'loading...',
            widthStyle:'',
            height:'',
        }
    },
    mounted() {
        // this.showMask = this.value;
        this.widthStyle = 'width:'+this.width+'%;margin-left:-'+this.width/2+'%';
    },
    created() {

    },
    methods: {
        //打开弹框
        showMaskFun () {
            let that = this;
            that.showMask = true;
        },
        closeMask(){
            // clearInterval(this.timer);
            this.showMask = false;
            this.height = '';
        },
        dangerBtn(){
            let that = this;
            // if(that.load == true){
            //     return;
            // }
            /*if(that.type === 'alert'){
                this.showMask = false;
                return;
            }*/
            let num = 0;
            this.callback();
            // setTimeout(() => {
            //     if(this.dialogShow == true){
            //         this.closeMask();
            //     }
            // }, 1);
        }
    }
}
</script>
<style lang="" scoped>
    .modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
    .modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
    .modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);background:none;border-radius:0.2rem;padding:0.3rem 0;min-height:3.3rem;}
    .modal-content2{padding:0px;}
    .modal-header{color: #333;font-size:0.3rem;padding: 0.1rem 0;font-weight: bold;border-bottom: 1px solid #aaa}
    .modal-header .close{width: .4rem;height: .4rem;border: 1px solid #666;border-radius: 50%;font-size: .34rem;font-weight: 200;text-align: center;line-height: .3rem;color: #414141;}
    .modal-warp{padding:0.2rem 0;font-size:0.33rem;color:#fff;}
    .modal-footer{padding:0.3rem 0 0.2rem;}
    .modal-footer .btn{box-shadow: none;font-size:0.3rem;color: #fff;padding: 0.1rem 0.1rem;border-radius: 0.1rem;width:47%;background: url(../../static/images/btn-modal.png) no-repeat 0 0;}
    .modal-footer .btn.btn-none{}
    .modal-footer .sig .btn{width: 45%;background-size: cover;height: 1.2rem;text-transform: uppercase;}
    .letModal .modal-header{margin-top:0.2rem}
    .letModal .modal-content{height:8.5rem;}
    .letModal .modal-footer .btn{background-color: #f3bb4d;color:#fff;position: absolute;bottom: 1.3rem;left: 8%;width: 84%;}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue